import React from 'react';
import { Image } from 'semantic-ui-react';
import { Fill, Left, Top } from 'react-spaces';
import { Link } from 'react-router-dom';
import { useResponsive } from 'ahooks';

import logo from 'src/assets/logo.png';
import logo_responsive from 'src/assets/logo_responsive.png';
import { useAppSelector } from 'src/store';

import Search from './Search';
import Menu from './Menu';
import UserDropdown from './UserDropdown';
import NotificationHistory from './NotificationHistory';

const Header: React.FC = () => {
  const layoutSplit = useAppSelector((state) => state.ui.app.layoutSplit);
  const screen = useResponsive();

  return (
    <Top as="header" className="overflow-visible app_header" size={80}>
      <Left size={layoutSplit} className="app_header_logo">
        <Link to={'/'}>
          {!screen.sm ? (
            <Image height={45} src={logo_responsive} alt="logo" />
          ) : (
            <Image width={140} height={45} src={logo} alt="logo" />
          )}
        </Link>
      </Left>
      <Fill className="app_header_action">
        <Search />
        <Menu />
        <NotificationHistory />
        <UserDropdown />
      </Fill>
    </Top>
  );
};

export default Header;
